import ConfigurableRenderer from './ConfigurableRenderer';

export default {
  __init__: ['ConfigurableRenderer'],
  ConfigurableRenderer: ['type', ConfigurableRenderer]
};
